module.exports = __webpack_public_path__ + "static/media/happy-april-fools-beiber.83f6d7ab.png";